export const GET_ALL_LEAGUES = "GET_ALL_LEAGUES";
export const GET_ALL_LEAGUES_RESPONSE_SUCCESS =
  "GET_ALL_LEAGUES_RESPONSE_SUCCESS";
